import Form, { ButtonItem, EmptyItem, Item, Label, SimpleItem } from 'devextreme-react/form';
import { useContext, useEffect, useRef, useState } from 'react';
import { DocumentiApi } from '../../../data';
import { ListiniApi } from '../../../data';
import { apiConfiguration } from '../../../apiConfig';
import FilieraContext from '../../../contexts/filieraContext';
import { ClickEvent } from 'devextreme/ui/button';
import { showError } from '../../../utils/errorHandling';
import React from 'react';
import LoadPanel from 'devextreme-react/load-panel';
import { FieldDataChangedEvent } from 'devextreme/ui/form';
import { filiereDataSource } from '../../../datasources/filiereDataSource';

type Props = {
    idListino?: number,
    tipoListino?: string,
    onUpdated: () => void,
    onInserted: (idListino: number) => void,
    readonly?: boolean
}

const ListiniAnimaliForm = (props: Props) => {

    const { currentFiliera } = useContext(FilieraContext);
    const [formData, setFormData] = useState<any>();
    const [loadPanelVisible, setLoadPanelVisible] = useState<boolean>(false);
    const formRef = useRef<Form>(null);

   useEffect(() => {
    setFormData(null);
    if (!props.idListino) return;

    const api = new ListiniApi(apiConfiguration);
    api.getListinoAnimaliById({ idListino: props.idListino })
        .then(setFormData)
        .catch(showError);
    }, [props.idListino]);



    function onFieldDataChanged(e: FieldDataChangedEvent) {
        if (e.dataField==="dataDocumento" && e.component.getEditor('dataOperazione')?.option('value')==null){
            e.component.updateData("dataOperazione", e.value);
        }   
    }

    return (
        <React.Fragment>
            <Form id="form" ref={formRef} colCount={3} formData={formData} onFieldDataChanged={onFieldDataChanged} labelMode='floating'>
                <Item dataField="idFiliera" editorType='dxSelectBox' disabled={true} editorOptions={{
                    dataSource: filiereDataSource, 
                    displayExpr: 'ragioneSociale', 
                    valueExpr: 'id', }}/>
                <Item dataField="cliente" disabled={true}/>
                <EmptyItem/>
            </Form>
            <LoadPanel
                shadingColor="rgba(0,0,0,0.4)"
                position={{ of: '#form' }}
                visible={loadPanelVisible}
                showIndicator={true}
                shading={true}
                showPane={true}
                hideOnOutsideClick={false}
            />
        </React.Fragment>
    );
};

export default ListiniAnimaliForm;
